import { resolveUserDevice } from "@di/app";

export function getUserPlatform(): string {
  return `Web-${resolveUserDevice()}`;
}
